import { useEffect, useState } from "react";
import {
  Alert,
  Badge,
  Button,
  Card,
  Carousel,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { AiFillIdcard } from "react-icons/ai";
import {
  FaArrowLeft,
  FaBox,
  FaCalendar,
  FaCalendarAlt,
  FaCarSide,
  FaCheck,
  FaCheckCircle,
  FaClock,
  FaComments,
  FaEuroSign,
  FaExpand,
  FaImages,
  FaLocationArrow,
  FaMapMarkerAlt,
  FaQuestionCircle,
  FaRulerCombined,
  FaStar,
  FaThumbsDown,
  FaThumbsUp,
  FaTimes,
  FaTruck,
  FaTrash,
  FaWeight,
  FaWeightHanging,
  FaPlus,
  FaMoneyBill,
} from "react-icons/fa";
import { HiWrenchScrewdriver } from "react-icons/hi2";
import Swal from "sweetalert2";
import {
  formatDisplayDate,
  formatNumber,
} from "../../utils/helpers";
import { userAPI } from "../../api/apiSystem";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import OrderDetailsModal from "./OrderDetailsModal";
import ClientChatBox from "../chat/ClientChatBox";
import "./TransportClientDetails.css";
import SpecialItemsSummary from "../movingBookingForm/SpecialItemsSummary";
import DriverRatingModal from "../rating/RatingModal";
import CustomerRatingDisplay from "../rating/CustomerRatingDisplay";
import { sendRatingChatMessage } from "../../utils/ratingChat";

export default function TransportClientDetails() {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const fromPage = location.state?.fromPage || 1;

  const [showOrder, setShowOrder] = useState(false);
  const [transport, setTransport] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [booking, setBooking] = useState(null);

  // 🔹 إضافة states للقبول والرفض
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [orderToReject, setOrderToReject] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectReasonError, setRejectReasonError] = useState("");
  const [processingAction, setProcessingAction] = useState(false);
  const [actionAlert, setActionAlert] = useState({
    show: false,
    message: "",
    variant: "",
  });

  // 🔹 Accept Modal states - الجديد
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [orderToAccept, setOrderToAccept] = useState(null);
  const [showLoadingEnd, setShowLoadingEnd] = useState(false);
  const [showUnloadingEnd, setShowUnloadingEnd] = useState(false);

const [acceptData, setAcceptData] = useState({
  booking_from: "",
  loading_name: "",
  loading_streat: "",
  loading_phone: "",
  loading_date: "",
  loading_date_start: "",
  loading_date_end: "",
  loading_time_start: "",
  loading_time_end: "",
  booking_to: "",
  unloading_name: "",
  unloading_streat: "",
  unloading_phone: "",
  unloading_date: "",
  unloading_date_start: "",
  unloading_date_end: "",
  unloading_time_start: "",
  unloading_time_end: "",
});

  // 🔹 Rating Modal states - الجديد
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);

  // 🔹 إضافة state لتتبع الرسائل غير المقروءة لكل طلب
  const [ordersUnreadCounts, setOrdersUnreadCounts] = useState({});

  const [userType, setUserType] = useState(
    typeof window !== "undefined" ? localStorage.getItem("userType") : null,
  );

  // 🔹 Back button function
  const handleBack = () => {
    const state = {
      fromPage: location.state?.fromPage || 1,
      currentPage: location.state?.currentPage || 1,
      highlightId: location.state?.highlightId || parseInt(id),
      scrollToHighlight: true,
      activeTab: location.state?.activeTab || "active",
    };

    navigate("/user/booking", {
      state: state,
    });
  };

  const handleViewTrack = (booking_id) => {
    navigate(`/user/booking/transport_details/transport-track/${booking_id}`);
  };

  const handleViewLiveTracking = (id) => {
    navigate(`/user/booking/transport_details/transport-live-track/${id}`);
  };

  const canDeleteTransport = () => {
    const deletableStatuses = ["pending", "approved"];
    const acceptedOrderStatuses = ["assigned", "received", "completed"];

    return (
      deletableStatuses.includes(transport?.status) &&
      Number(transport?.order_status) !== 1 &&
      !acceptedOrderStatuses.includes(transport?.order?.status)
    );
  };

  const handleDeleteTransport = async () => {
    const reasonResult = await Swal.fire({
      icon: "warning",
      title:
        transport?.transport_type === "car"
          ? t("clientTable.deleteModal.deleteCarTransport")
          : t("clientTable.deleteModal.deleteFurnitureTransport"),
      text: t("clientTable.deleteModal.confirmDelete"),
      input: "textarea",
      inputPlaceholder: t("clientTable.deleteModal.reasonPlaceholder"),
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("clientTable.buttons.confirmDelete"),
      cancelButtonText: t("clientTable.buttons.cancel"),
      inputValidator: (value) => {
        if (!value?.trim()) {
          return t("clientTable.deleteModal.reasonRequired");
        }
        return undefined;
      },
    });

    if (!reasonResult.isConfirmed) {
      return;
    }

    try {
      Swal.fire({
        title: t("clientTable.deleteModal.deleting"),
        text: t("clientTable.deleteModal.pleaseWait"),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await userAPI.transports.delete(id, {
        deleted_reason: reasonResult.value.trim(),
      });

      if (!response.success) {
        throw new Error(response.message || t("clientTable.deleteModal.failedToDelete"));
      }

      await Swal.fire({
        icon: "success",
        title: t("clientTable.deleteModal.success"),
        text: t("clientTable.deleteModal.deletedSuccessfully"),
        confirmButtonColor: "#ff7b00",
      });

      navigate("/user/booking", {
        state: {
          fromPage,
          currentPage: fromPage,
          activeTab: transport?.transport_type === "car" ? "car" : "furniture",
        },
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: t("clientTable.deleteModal.deleteFailed"),
        text: err.message || t("clientTable.deleteModal.deletionError"),
        confirmButtonColor: "#ff7b00",
      });
    }
  };

  // دالة لترجمة حالة الـ status
  const translateStatus = (status) => {
    if (!status) return t("clientTransportDetails.status_unknown");

    const statusMap = {
      completed: t("clientTransportDetails.status_completed"),
      pending: t("clientTransportDetails.status_pending"),
      accepted: t("clientTransportDetails.status_accepted"),
      rejected: t("clientTransportDetails.status_rejected"),
      assigned: t("clientTransportDetails.status_assigned"),
      received: t("clientTransportDetails.status_received"),
      approved: t("clientTransportDetails.status_approved"),
    };

    return statusMap[status] || status;
  };

  const fetchTransportDetails = async () => {
    try {
      setLoading(true);
      setError(null);

      const transportId = id;

      console.log("🔄 Fetching transport details for ID:", transportId);

      const response = await userAPI.transports.show(transportId);

      console.log("Transport details:", response);

      if (response.success) {
        const transportData = response.data.data || response.data;
        setTransport(transportData);

        // 🔍 عرض البيانات المهمة للتصحيح
        console.log("📋 Important transport data:", {
          booking_from: transportData.booking_from,
          booking_to: transportData.booking_to,
          loading_date: transportData.loading_date,
          loading_date_start: transportData.loading_date_start,
          loading_time: transportData.loading_time,
          unloading_date: transportData.unloading_date,
          unloading_time: transportData.unloading_time,
          loading_name: transportData.loading_name,
          loading_phone: transportData.loading_phone,
          unloading_name: transportData.unloading_name,
          unloading_phone: transportData.unloading_phone,
        });
      } else {
        setError(
          response.message || t("clientTransportDetails.error_occurred"),
        );
      }
    } catch (err) {
      console.error("❌ Error fetching transport details:", err);
      setError(err.message || t("clientTransportDetails.error_occurred"));
    } finally {
      setLoading(false);
    }
  };

  // جلب بيانات الطلبات
  const fetchOrders = async () => {
    try {
      setError(null);

      const transportId = id;

      console.log("🔄 Fetching orders for transport ID:", transportId);

      const response = await userAPI.transportsOrders.byTransport(transportId);

      console.log("📦 API Response:", response);

      if (response.success) {
        const ordersData = response.data.data || response.data;
        setOrders(ordersData);

        // جلب عدد الرسائل غير المقروءة لكل طلب
        await fetchUnreadCountsForOrders(ordersData);
      } else {
        setError(
          response.message || t("clientTransportDetails.error_occurred"),
        );
      }
    } catch (err) {
      console.error("❌ Error fetching orders:", err);
      setError(err.message || t("clientTransportDetails.error_occurred"));
    }
  };

  // دالة لجلب عدد الرسائل غير المقروءة لكل طلب
  const fetchUnreadCountsForOrders = async (ordersData) => {
    const unreadCounts = {};

    for (const order of ordersData) {
      try {
        const transportId = order.transport?.id || order.transport_id;
        const orderId = order.id;

        if (!transportId || !orderId) continue;

        console.log("📊 Fetching unread count for order:", orderId);

        const response = await userAPI.transportOrderChat.getMessages(
          transportId,
          orderId,
        );

        if (response.success) {
          let statistics = { unread_count: 0 };

          if (response.data && response.data.statistics) {
            statistics = response.data.statistics;
          } else if (
            response.data &&
            response.data.data &&
            response.data.data.statistics
          ) {
            statistics = response.data.data.statistics;
          }

          unreadCounts[orderId] = statistics.unread_count || 0;
          console.log(
            `📊 Unread count for order ${orderId}:`,
            statistics.unread_count,
          );
        }
      } catch (err) {
        console.error(
          `❌ Error fetching unread count for order ${order.id}:`,
          err,
        );
        unreadCounts[order.id] = 0;
      }
    }

    setOrdersUnreadCounts(unreadCounts);
  };

  // دالة لتحديث عدد الرسائل غير المقروءة لطلب معين
  const updateOrderUnreadCount = (orderId, newCount) => {
    setOrdersUnreadCounts((prev) => ({
      ...prev,
      [orderId]: newCount,
    }));
  };

  useEffect(() => {
    if (id) {
      fetchTransportDetails();
      fetchOrders();
    } else {
      setError(t("clientTransportDetails.no_transport_id"));
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const openChat = searchParams.get("openChat") === "true";
    const orderIdParam = searchParams.get("orderId");

    if (openChat && orderIdParam && orders.length > 0) {
      const matchingOrder = orders.find(
        (o) => String(o.id) === String(orderIdParam)
      );
      if (matchingOrder) {
        handleShowOrder(matchingOrder);
        // Clean up the URL search params so it doesn't open again on reload
        navigate(location.pathname, { replace: true });
      }
    }
  }, [orders, location.search, navigate]);

  // معالجة فتح Modal وعرض تفاصيل الطلب
  const handleShowOrder = (order) => {
    setSelectedOrder(order);
    setShowOrder(true);
  };

  // ✅ دالة استخراج الـ transport_id و order_id من البيانات
  const getTransportAndOrderIds = (order) => {
    console.log("🔍 Analyzing order data:", order);

    let transportId = null;
    let orderId = null;

    if (order.transport && order.transport.id) {
      transportId = order.transport.id;
      orderId = order.id;
      console.log("✅ Found in transport object:", { transportId, orderId });
    } else if (order.transport_id) {
      transportId = order.transport_id;
      orderId = order.id;
      console.log("✅ Found direct transport_id:", { transportId, orderId });
    } else if (order.id) {
      orderId = order.id;
      console.log("⚠️ Only found orderId:", orderId);
    }

    return { transportId, orderId };
  };

  // ✅ دالة قبول الطلب
  const handleAcceptOrder = async (order) => {
    const { transportId, orderId } = getTransportAndOrderIds(order);

    console.log("🚀 handleAcceptOrder called with:", {
      order,
      transportId,
      orderId,
    });

    if (!transportId || !orderId) {
      alert(
        `بيانات الطلب غير مكتملة. transportId: ${transportId}, orderId: ${orderId}`,
      );
      console.error("❌ Missing data:", { transportId, orderId, order });
      return;
    }

    try {
      setProcessingAction(true);
      setActionAlert({ show: false, message: "", variant: "" });

      console.log("📤 Sending accept request:", { transportId, orderId });
      const response = await userAPI.transportsOrders.accept(
        transportId,
        orderId,
      );

      if (response.success) {
        Swal.fire({
          icon: "success",
          title: t("clientTransportDetails.order_accepted_success"),
          text: t("clientTransportDetails.order_accepted_successfully"),
          timer: 2000, // Show for 2 seconds
          showConfirmButton: false,
        });

        setTimeout(() => {
          fetchOrders(); // إعادة تحميل البيانات
        }, 1500);
      } else {
        setActionAlert({
          show: true,
          message:
            response.message || t("clientTransportDetails.error_occurred"),
          variant: "danger",
        });
      }
    } catch (error) {
      console.error("Error accepting order:", error);
      setActionAlert({
        show: true,
        message: error.message || t("clientTransportDetails.error_occurred"),
        variant: "danger",
      });
    } finally {
      setProcessingAction(false);
    }
  };

  // ✅ دالة فتح مودال القبول مع تعيين القيم الافتراضية من بيانات الـ transport
  const handleShowAcceptModal = (order) => {
    const { transportId, orderId } = getTransportAndOrderIds(order);

    console.log("🚀 handleShowAcceptModal called with:", {
      order,
      transportId,
      orderId,
    });

    if (!transportId || !orderId) {
      alert(
        `بيانات الطلب غير مكتملة. transportId: ${transportId}, orderId: ${orderId}`,
      );
      console.error("❌ Missing data:", { transportId, orderId, order });
      return;
    }

    const userData = order.user || {};
    const transportData = transport || {};

    // تعيين الحالة الأولية للتواريخ المخفية
    setShowLoadingEnd(false);
    setShowUnloadingEnd(false);

    setOrderToAccept({ ...order, transportId, orderId });

    setAcceptData({
      booking_from: transportData?.booking_from || "",
      loading_name: userData?.loading_name || transportData?.loading_name || "",
      loading_streat: transportData?.loading_streat || "",
      loading_phone: userData?.loading_phone || transportData?.loading_phone || "",
      loading_date: transportData?.loading_date || "",
      loading_date_start: transportData?.loading_date_start || "",
      loading_date_end: transportData?.loading_date_end || "",
      loading_time_start: transportData?.loading_time_start || "",
      loading_time_end: transportData?.loading_time_end || "",
      booking_to: transportData?.booking_to || "",
      unloading_name: userData?.unloading_name || transportData?.unloading_name || "",
      unloading_streat: transportData?.unloading_streat || "",
      unloading_phone: userData?.unloading_phone || transportData?.unloading_phone || "",
      unloading_date: transportData?.unloading_date || "",
      unloading_date_start: transportData?.unloading_date_start || "",
      unloading_date_end: transportData?.unloading_date_end || "",
      unloading_time_start: transportData?.unloading_time_start || "",
      unloading_time_end: transportData?.unloading_time_end || "",
    });

    setActionAlert({ show: false, message: "", variant: "" });
    setShowAcceptModal(true);
  };

  // ✅ دالة تحديث بيانات النموذج
  const handleAcceptDataChange = (e) => {
    const { name, value } = e.target;
    setAcceptData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ Helper to convert German date to ISO format
  const convertGermanDateToISO = (germanDate) => {
    if (!germanDate || germanDate.length < 10) return null;
    const parts = germanDate.split(".");
    if (parts.length !== 3) return null;
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
    return `${year}-${month}-${day}`;
  };

  const PAYMENT_TERM_LABELS = {
    on_delivery: "Bei Lieferung",
    "3_days": "3 Tage",
    "7_days": "7 Tage",
    "14_days": "14 Tage",
    "30_days": "30 Tage",
    by_agreement: "Nach Vereinbarung",
  };

  /** بناء رسالة كارت العرض (قبول / رفض / إرسال) */
  const buildOfferStatusMessage = (order, status) => {
    const transportData = order?.transport || transport || {};

    const fromRaw =
      transportData.booking_from ?? order?.booking_from ?? null;
    const toRaw = transportData.booking_to ?? order?.booking_to ?? null;

    const from = Array.isArray(fromRaw) ? fromRaw[0] : fromRaw;
    const to = Array.isArray(toRaw) ? toRaw[0] : toRaw;

    const paymentTermKey =
      transportData.payment_term ?? order?.payment_term ?? "";
    const paymentTermLabel =
      PAYMENT_TERM_LABELS[paymentTermKey] || paymentTermKey || "";

    const payload = {
      type: "offer_card",
      status, // "accepted" | "rejected"
      from: from || "N/A",
      to: to || "N/A",
      price: String(order?.price ?? "-"),
      currency: "EUR",
      payment_term: paymentTermLabel,
      valid_until: order?.offer_date || "",
    };

    return `__OFFER_CARD__${JSON.stringify(payload)}`;
  };

  /** إرسال رسالة حالة العرض في الشات بعد قبول/رفض */
  const sendOfferStatusChatMessage = async (order, status) => {
    try {
      const transportId = order.transport?.id || order.transport_id || order.transportId;
      const orderId = order.id || order.orderId;

      if (!transportId || !orderId) {
        console.warn("⚠️ Missing IDs for status chat message", {
          transportId,
          orderId,
        });
        return;
      }

      const formData = new FormData();
      formData.append("message", buildOfferStatusMessage(order, status));

      const result = await userAPI.transportOrderChat.sendMessage(
        transportId,
        orderId,
        formData,
        true,
      );

      if (!result?.success) {
        console.error("❌ Status chat message failed:", result?.message);
      }
    } catch (err) {
      // ثانوي — مش يوقف قبول/رفض الطلب
      console.error("❌ Error sending status chat message:", err);
    }
  };

  // ✅ دالة تأكيد قبول الطلب وإرسال البيانات
  const handleConfirmAccept = async () => {
    try {
      setProcessingAction(true);
      setActionAlert({ show: false, message: "", variant: "" });

      // Convert German dates to ISO format for API
      const dataToSend = {
        ...acceptData,
        loading_date_start:
          convertGermanDateToISO(acceptData.loading_date) ||
          acceptData.loading_date,
        loading_date_end:
          convertGermanDateToISO(acceptData.loading_date_end) ||
          acceptData.loading_date_end,
        unloading_date_start:
          convertGermanDateToISO(acceptData.unloading_date) ||
          acceptData.unloading_date,
        unloading_date_end:
          convertGermanDateToISO(acceptData.unloading_date_end) ||
          acceptData.unloading_date_end,
      };

      console.log("📤 Sending accept request with data:", {
        transportId: orderToAccept.transportId,
        orderId: orderToAccept.orderId,
        dataToSend,
      });

      // هنا يمكنك إرسال البيانات الإضافية مع طلب القبول
      const response = await userAPI.transportsOrders.accept(
        orderToAccept.transportId,
        orderToAccept.orderId,
        dataToSend, // إرسال البيانات الإضافية
      );

      console.log("🌀🌀Accept response:", response);

      if (response.success) {
        await sendOfferStatusChatMessage(orderToAccept, "accepted");

        Swal.fire({
          icon: "success",
          title: t("clientTransportDetails.order_accepted_success"),
          text: t("clientTransportDetails.order_accepted_successfully"),
          timer: 3000,
          showConfirmButton: false,
        });

        setTimeout(() => {
          setShowAcceptModal(false);
          fetchOrders(); // إعادة تحميل البيانات
        }, 1500);
      } else {
        setActionAlert({
          show: true,
          message:
            response.message || t("clientTransportDetails.error_occurred"),
          variant: "danger",
        });
      }
    } catch (error) {
      console.error("Error accepting order:", error);
      setActionAlert({
        show: true,
        message: error.message || t("clientTransportDetails.error_occurred"),
        variant: "danger",
      });
    } finally {
      setProcessingAction(false);
    }
  };

  // ✅ دالة إغلاق مودال القبول
  const handleCloseAcceptModal = () => {
    setShowAcceptModal(false);
    setOrderToAccept(null);
    setShowLoadingEnd(false);
    setShowUnloadingEnd(false);
    setAcceptData({
      booking_from: "",
      loading_name: "",
      loading_streat: "",
      loading_phone: "",
      loading_date: "",
      loading_date_start: "",
      loading_date_end: "",
      loading_time_start: "",
      loading_time_end: "",
      booking_to: "",
      unloading_name: "",
      unloading_streat: "",
      unloading_phone: "",
      unloading_date: "",
      unloading_date_start: "",
      unloading_date_end: "",
      unloading_time_start: "",
      unloading_time_end: "",
    });
  };

  // ✅ دالة عرض موودال الرفض
  const handleShowRejectModal = (order) => {
    const { transportId, orderId } = getTransportAndOrderIds(order);

    if (!transportId || !orderId) {
      alert(
        `بيانات الطلب غير مكتملة. transportId: ${transportId}, orderId: ${orderId}`,
      );
      console.error("❌ Missing data for reject:", {
        transportId,
        orderId,
        order,
      });
      return;
    }

    setOrderToReject({ ...order, transportId, orderId });
    setRejectReason("");
    setRejectReasonError("");
    setActionAlert({ show: false, message: "", variant: "" });
    setShowRejectModal(true);
  };

  // ✅ دالة تأكيد الرفض
  const handleConfirmReject = async () => {
    if (!orderToReject) return;

    if (!rejectReason.trim()) {
      setRejectReasonError(t("clientTransportDetails.reason_rejection"));
      return;
    }

    try {
      setProcessingAction(true);
      setRejectReasonError("");

      const response = await userAPI.transportsOrders.reject(
        orderToReject.transportId,
        orderToReject.orderId,
        { rejected_reason: rejectReason.trim() },
      );

      if (response.success) {
        await sendOfferStatusChatMessage(orderToReject, "rejected");

        Swal.fire({
          icon: "success",
          title: t("clientTransportDetails.order_rejected_success"),
          text: t("clientTransportDetails.order_rejected_successfully"),
          timer: 2000, // Show for 2 seconds
          showConfirmButton: false,
        });

        setTimeout(() => {
          setShowRejectModal(false);
          setRejectReason("");
          fetchOrders(); // إعادة تحميل البيانات
        }, 1500);
      } else {
        setActionAlert({
          show: true,
          message:
            response.message || t("clientTransportDetails.error_occurred"),
          variant: "danger",
        });
      }
    } catch (error) {
      console.error("Error rejecting order:", error);
      setActionAlert({
        show: true,
        message: error.message || t("clientTransportDetails.error_occurred"),
        variant: "danger",
      });
    } finally {
      setProcessingAction(false);
    }
  };

  const handleCloseRejectModal = () => {
    setShowRejectModal(false);
    setRejectReason("");
    setRejectReasonError("");
    setActionAlert({ show: false, message: "", variant: "" });
  };

  // 🔹 دالة إرسال التقييم - الجديد
  const handleSubmitRating = async (payload) => {
    const completedOrder =
      transport?.order ||
      orders?.find((o) => o.status === "completed") ||
      orders?.[0];

    const transportId =
      completedOrder?.transport_id ||
      completedOrder?.transport?.id ||
      transport?.id ||
      id;

    const orderId = completedOrder?.id;

    if (!transportId || !orderId) {
      Swal.fire({
        icon: "error",
        title: t("clientTransportDetails.error_occurred"),
        text: "Transport oder Auftrag nicht gefunden",
      });
      return;
    }

    console.log('payyyyy', payload);

    try {
      setSubmitting(true);
      const res = await userAPI.transportsOrders.rating(
        id,
        payload,
      );
      // payload = { punctuality, communication, cargo_care, rating, comment }

      if (res.success) {
        await sendRatingChatMessage({
          apiSendMessage: userAPI.transportOrderChat.sendMessage,
          transportId,
          orderId,
          item: transport || completedOrder?.transport, 
          order: completedOrder,
          scores: payload,
          direction: "customer_to_driver",
        });

        Swal.fire({
          icon: "success",
          title: t("clientTransportDetails.success_rating_title"),
          text: t("clientTransportDetails.success_rating_text"),
          timer: 2500,
          showConfirmButton: false,
        });
        setShowRatingModal(false);
        const updated = await userAPI.transports.show(id);
        setTransport(updated.data.data || updated.data);
        await fetchOrders();
      } else {
        Swal.fire({
          icon: "error",
          title: t("clientTransportDetails.error_rating_title"),
          text: res.message || t("clientTransportDetails.error_rating_text"),
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: t("clientTransportDetails.error_occurred"),
        text: err.message,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const ImageGallery = ({ images, className = "" }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const { t } = useTranslation();

    if (!images || images.length === 0) {
      return null;
    }

    const handleImageClick = (index) => {
      setSelectedIndex(index);
      setShowModal(true);
    };

    const handleCloseModal = () => {
      setShowModal(false);
    };

    return (
      <>
        <Card className="mb-4 shadow-sm border-0">
          <Card.Header className="bg-orange text-white fw-bold d-flex align-items-center">
            <FaImages className="me-2" />
            {t("driverCard.transportDetails.images")} ({images.length})
          </Card.Header>
          <Card.Body>
            <div className={`image-gallery ${className}`}>
              <div className="d-flex flex-wrap gap-2">
                {images.slice(0, 4).map((image, index) => (
                  <div
                    key={index}
                    className="thumbnail-container position-relative"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleImageClick(index)}
                  >
                    <img
                      src={image}
                      alt={`Transport ${index + 1}`}
                      className="thumbnail img-thumbnail"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                    <div className="thumbnail-overlay">
                      <FaExpand className="text-white" size={12} />
                    </div>

                    {/* مؤشر الصور الإضافية */}
                    {index === 3 && images.length > 4 && (
                      <div className="more-images-badge">
                        +{images.length - 4}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* Modal لتكبير الصور */}
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          size="lg"
          centered
          className="image-modal"
        >
          <Modal.Header className="border-0 pb-0">
            <div className="d-flex justify-content-between align-items-center w-100">
              <h6 className="mb-0 text-dark">
                {t("images")} ({selectedIndex + 1} / {images.length})
              </h6>
              <Button
                variant="link"
                className="text-dark p-0"
                onClick={handleCloseModal}
              >
                <FaTimes size={20} />
              </Button>
            </div>
          </Modal.Header>

          <Modal.Body className="text-center p-0">
            <Carousel
              activeIndex={selectedIndex}
              onSelect={setSelectedIndex}
              interval={null}
              indicators={images.length > 1}
              controls={images.length > 1}
            >
              {images.map((image, index) => (
                <Carousel.Item key={index}>
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src={image}
                      alt={`Transport ${index + 1}`}
                      className="img-fluid modal-image"
                      style={{
                        maxHeight: "70vh",
                        objectFit: "contain",
                        borderRadius: "8px",
                      }}
                    />
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </Modal.Body>
        </Modal>
      </>
    );
  };

  // دالة لتنسيق التاريخ
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("de-DE");
  };

  // دالة للحصول على لون الحالة
  const getStatusVariant = (status) => {
    switch (status) {
      case "completed":
        return "success";
      case "pending":
        return "warning";
      case "accepted":
        return "primary";
      case "rejected":
        return "danger";
      default:
        return "secondary";
    }
  };

  // ✅ التحقق إذا كان يمكن عرض أزرار القبول والرفض
  const showAcceptRejectButtons = (order) => {
    const isPending = order.status === "pending";
    const { transportId, orderId } = getTransportAndOrderIds(order);
    const hasRequiredData = transportId && orderId;

    console.log(`🔍 showAcceptRejectButtons for order ${order.id}:`, {
      isPending,
      transportId,
      orderId,
      hasRequiredData,
    });

    return isPending && hasRequiredData;
  };

  const PAYMENT_TERM_OPTIONS = [
    { value: "on_delivery", label: t("delivery_summary.paymentTerms.onDelivery", "Bei Lieferung") },
    { value: "7_days", label: t("delivery_summary.paymentTerms.after7Days", "7 Tage nach Lieferung") },
    { value: "14_days", label: t("delivery_summary.paymentTerms.after14Days", "14 Tage nach Lieferung") },
    { value: "30_days", label: t("delivery_summary.paymentTerms.after30Days", "30 Tage nach Lieferung") },
    { value: "3_days", label: t("delivery_summary.paymentTerms.after3Days", "3 Tage nach Lieferung") },
    { value: "by_agreement", label: t("delivery_summary.paymentTerms.byAgreement", "Nach Vereinbarung") },
  ];

  const newLocal = "#ff7b00";
  const orderStatus = transport?.order?.status?.toLowerCase();
  const showLiveTracking = Boolean(transport?.order) && !["pending", "completed"].includes(orderStatus);
  return (
    <>
      <NavbarMenu />
      <div className="transport-details-page">
        <Container className="py-4">
          {/* 🔹 Back Button */}
          <div className="d-flex flex-wrap gap-2 mb-4 align-items-center">
            <Button variant="secondary" onClick={handleBack} size="sm">
              <FaArrowLeft className="me-1" />
              {t("clientDetails.back")}
            </Button>

            <Button
              variant="outline"
              style={{ color: newLocal, borderColor: newLocal }}
              size="sm"
              onClick={() => handleViewTrack(transport?.booking_id)}
            >
              <FaTruck className="me-1" /> {t("clientDetails.track")}
            </Button>

            {showLiveTracking && (
              <Button
                variant="outline-success"
                size="sm"
                onClick={() => handleViewLiveTracking(transport.order?.id)}
              >
                <FaLocationArrow className="me-1" />{" "}
                {t("clientDetails.live_tracking")}
              </Button>
            )}

            {canDeleteTransport() && (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={handleDeleteTransport}
              >
                <FaTrash className="me-1" />
                {t("clientTable.buttons.deleteOrder")}
              </Button>
            )}
          </div>

          {/* 🔹 Progress Status - Dark Theme */}
          <div className="progress-container">
            <div className="d-flex justify-content-between align-items-center">
              {/* Created */}
              <div className="text-center">
                <div
                  className={`progress-step-circle ${transport?.status === "approved" ||
                    transport?.status === "assigned" ||
                    transport?.status === "received" ||
                    transport?.status === "completed"
                    ? "completed"
                    : ""
                    }`}
                >
                  <FaCheckCircle
                    size={24}
                    className={`icon ${transport?.status === "approved" ||
                      transport?.status === "assigned" ||
                      transport?.status === "received" ||
                      transport?.status === "completed"
                      ? "text-orange"
                      : ""
                      }`}
                  />
                </div>
                <p
                  className={`progress-label ${transport?.status ? "active" : ""
                    }`}
                >
                  {t("clientTransportDetails.created")}
                </p>
              </div>

              <div
                className={`progress-line ${transport?.status === "received" ||
                  transport?.status === "completed"
                  ? "active"
                  : ""
                  }`}
              ></div>

              {/* On the way */}
              <div className="text-center">
                <div
                  className={`progress-step-circle ${transport?.status === "received" ||
                    transport?.status === "completed"
                    ? "active"
                    : ""
                    }`}
                >
                  <FaCarSide
                    size={24}
                    className={`icon ${transport?.status === "received" ||
                      transport?.status === "completed"
                      ? "text-white"
                      : ""
                      }`}
                  />
                </div>
                <p
                  className={`progress-label ${transport?.status === "received" ||
                    transport?.status === "completed"
                    ? "active"
                    : ""
                    }`}
                >
                  {t("clientTransportDetails.on_the_way")}
                </p>
              </div>

              <div
                className={`progress-line ${transport?.status === "completed" ? "active" : ""
                  }`}
              ></div>

              {/* Completed */}
              <div className="text-center">
                <div
                  className={`progress-step-circle ${transport?.status === "completed" ? "completed" : ""
                    }`}
                >
                  <FaCheckCircle
                    size={24}
                    className={`icon ${transport?.status === "completed" ? "text-orange" : ""
                      }`}
                  />
                </div>
                <p
                  className={`progress-label ${transport?.status === "completed" ? "active" : ""
                    }`}
                >
                  {t("clientTransportDetails.completed_status")}
                </p>
              </div>
            </div>
          </div>

          {/* 🔹 Main Title */}
          <h4 className="main-title">
            {t("clientTransportDetails.furniture_car_transport")}
          </h4>
          <p className="sub-title">
            Transport ID: {transport?.booking_id} |{" "}
            {translateStatus(transport?.status)}
          </p>

          {/* Action Alert */}
          {actionAlert.show && (
            <Alert variant={actionAlert.variant} className="mb-3">
              {actionAlert.message}
            </Alert>
          )}

          {loading && (
            <div className="text-center py-5">
              <Spinner animation="border" className="text-orange" />
              <p className="mt-2 text-white">
                {t("clientTransportDetails.loading_data")}
              </p>
            </div>
          )}

          {error && (
            <Alert variant="danger" className="text-center">
              {error}
            </Alert>
          )}

          {/* عرض تفاصيل الـ Transport */}
          {!loading && !error && transport && (
            <Row className="g-4 p-3 rounded-3">
              {/* Left Column - Transportdetails */}
              <Col md={6}>
                <Card className="detail-card h-100">
                  <Card.Header>
                    <div className="card-header-title">
                      <FaTruck className="icon" />
                      {t("clientTransportDetails.transport_details")}
                    </div>
                  </Card.Header>
                  <Card.Body>
                    {/* Transport Number & Type */}
                    <div className="transport-number">
                      {t("clientTransportDetails.order_number")}{" "}
                      {transport.booking_id}
                      <span className="transport-type-badge">
                        {t(transport.transport_type)}
                      </span>
                    </div>

                    {/* Status */}
                    <div className="mb-3">
                      <span className="me-2">Status:</span>
                      <span className={`status-badge ${transport.status}`}>
                        {translateStatus(transport.status)}
                      </span>
                    </div>

                    {/* Route Information */}
                    <div className="section-header">
                      {t("clientTransportDetails.route_information")}
                    </div>

                    <div className="info-row">
                      <FaMapMarkerAlt className="icon text-orange" />
                      <span>
                        {transport.booking_from} ({transport.from_codes})
                      </span>
                    </div>

                    <div className="info-row">
                      <FaMapMarkerAlt
                        className="icon"
                        style={{ color: "#6c6c70" }}
                      />
                      <span>
                        {transport.booking_to} ({transport.to_codes})
                      </span>
                    </div>

                    <div className="info-row mt-2">
                      <FaTruck className="icon" />
                      <span>
                        <strong>{t("clientTransportDetails.distance")}:</strong>{" "}
                        {transport.distance}
                        <span className="mx-2">|</span>
                        <FaClock
                          className="icon"
                          style={{ display: "inline", marginRight: "4px" }}
                        />
                        {transport.total_duration}
                      </span>
                    </div>

                    {/* Additional Info Accordion */}
                    <div
                      className="accordion-toggle mt-3"
                      onClick={(e) => {
                        e.currentTarget.classList.toggle("open");
                        e.currentTarget.nextElementSibling?.classList.toggle(
                          "d-none",
                        );
                      }}
                    >
                      <span>{t("clientTransportDetails.additional_info")}</span>
                      <span className="icon">+</span>
                    </div>
                    <div className="d-none mt-2">
                      {transport.delivery_as && (
                        <div className="info-row">
                          <strong>
                            {t("clientTransportDetails.delivery_as")}:
                          </strong>
                          <span className="ms-1">
                            {t(transport.delivery_as)}
                          </span>
                        </div>
                      )}

                      {(transport.description || transport.message || transport.user_note || transport.notizen) && (
                        <div className="info-row mt-2">
                          <strong>
                            {t("delivery_summary.additional_notes")}:
                          </strong>
                          <span className="ms-1">
                            {transport.description || transport.message || transport.user_note || transport.notizen}
                          </span>
                        </div>
                      )}
                    </div>

                    {transport.images && (
                      <ImageGallery images={transport.images} />
                    )}

                    <CustomerRatingDisplay
                      rating={transport.customerRating}
                      comment={transport.customerRating?.comment || transport.comment}
                    />
                  </Card.Body>
                </Card>
              </Col>

              {/* Right Column - Loading & Unloading */}
              <Col md={6}>
                <Card className="detail-card h-100">
                  <Card.Header>
                    <div className="card-header-title">
                      <FaBox className="icon" />
                      {t("clientTransportDetails.loading_unloading")}
                    </div>
                  </Card.Header>
                  <Card.Body>
                    {/* Loading Info */}
                    <div className="info-section">
                      <div className="info-section-title">
                        {t("clientTransportDetails.loading_info")}
                      </div>
                      {(transport.loading_date_start || transport.loading_date) && (
                        <div className="info-item">
                          <FaCalendarAlt className="icon" />
                          <span className="label">
                            {t("clientTransportDetails.date")}:
                          </span>
                          <span className="value">
                            {transport.loading_date || transport.loading_date_start}
                          </span>
                        </div>
                      )}
                      {transport.loading_time && (
                        <div className="info-item">
                          <FaClock className="icon" />
                          <span className="label">
                            {t("clientTransportDetails.time")}:
                          </span>
                          <span className="value">
                            {transport.loading_time}
                          </span>
                        </div>
                      )}
                      {transport.loading_name && (
                        <div className="info-item">
                          <span className="label">{t("Name")}:</span>
                          <span className="value">
                            {transport.loading_name}
                          </span>
                        </div>
                      )}
                      {transport.loading_streat && (
                        <div className="info-item">
                          <span className="label">
                            {t("clientTransportDetails.address")}:
                          </span>
                          <span className="value">
                            {transport.loading_streat}
                          </span>
                        </div>
                      )}
                      {transport.loading_phone && (
                        <div className="info-item">
                          <span className="label">
                            {t("clientTransportDetails.phone_number")}:
                          </span>
                          <span className="value">
                            {transport.loading_phone}
                          </span>
                        </div>
                      )}
                      {(transport.loading_elevator !== null) && (
                        <div className="info-item">
                          <span className="label">
                            {t("driverCard.transportDetails.loadingElevator")}:
                          </span>
                          <span className="value">
                            {transport.loading_elevator === 1
                              ? t("yes")
                              : t("no")}
                          </span>
                        </div>
                      )}
                      {transport.loading_floor &&
                        transport.loading_floor !== "" && (
                          <div className="info-item">
                            <span className="label">
                              {t("driverCard.transportDetails.loadingFloor")}:
                            </span>
                            <span className="value">
                              {t("driverCard.transportDetails.floor")}{" "}
                              {transport.loading_floor}
                            </span>
                          </div>
                        )}
                    </div>

                    {/* Unloading Info */}
                    <div className="info-section">
                      <div className="info-section-title">
                        {t("clientTransportDetails.unloading_info")}
                      </div>
                      {(transport.unloading_date_start || transport.unloading_date) && (
                        <div className="info-item">
                          <FaCalendarAlt className="icon" />
                          <span className="label">
                            {t("clientTransportDetails.date")}:
                          </span>
                          <span className="value">
                            {transport.unloading_date || transport.unloading_date_start}
                          </span>
                        </div>
                      )}
                      {transport.unloading_time && (
                        <div className="info-item">
                          <FaClock className="icon" />
                          <span className="label">
                            {t("clientTransportDetails.time")}:
                          </span>
                          <span className="value">
                            {transport.unloading_time}
                          </span>
                        </div>
                      )}
                      {transport.unloading_name && (
                        <div className="info-item">
                          <span className="label">{t("Name")}:</span>
                          <span className="value">
                            {transport.unloading_name}
                          </span>
                        </div>
                      )}
                      {transport.unloading_streat && (
                        <div className="info-item">
                          <span className="label">
                            {t("clientTransportDetails.address")}:
                          </span>
                          <span className="value">
                            {transport.unloading_streat}
                          </span>
                        </div>
                      )}
                      {transport.unloading_phone && (
                        <div className="info-item">
                          <span className="label">
                            {t("clientTransportDetails.phone_number")}:
                          </span>
                          <span className="value">
                            {transport.unloading_phone}
                          </span>
                        </div>
                      )}
                      {(transport.unloading_elevator !== null) && (
                        <div className="info-item">
                          <span className="label">
                            {t("driverCard.transportDetails.unloadingElevator")}:
                          </span>
                          <span className="value">
                            {transport.unloading_elevator === 1
                              ? t("yes")
                              : t("no")}
                          </span>
                        </div>
                      )}
                      {/* unloading_floor - يظهر فقط إذا كانت قيمته موجودة */}
                      {transport.unloading_floor &&
                        transport.unloading_floor !== "" && (
                          <div className="info-item">
                            <span className="label">
                              {t("driverCard.transportDetails.unloadingFloor")}:
                            </span>
                            <span className="value">
                              {t("driverCard.transportDetails.floor")}{" "}
                              {transport.unloading_floor}
                            </span>
                          </div>
                        )}
                    </div>

                    {/* Items Information */}
                    <div className="info-section">
                      <div className="info-section-title ">
                        {t("clientTransportDetails.items_information")}
                      </div>

                      {transport.item_breakable != null && (
                        <div className="info-item mb-2">
                          <FaQuestionCircle className="icon" />
                          <span className="label">
                            {t("dynamic_form.fragile_question")}:
                          </span>
                          <span className="value">
                            {transport.item_breakable == "1"
                              ? t("dynamic_form.yes")
                              : t("dynamic_form.no")}
                          </span>
                          {transport.item_breakable_details && (
                            <>
                              ,
                              <span className="value ms-1">
                                {transport.item_breakable_details}
                              </span>
                            </>
                          )}
                        </div>
                      )}

                      {transport.special_treatment != null && (
                        <div className="info-item mb-2">
                          <FaQuestionCircle className="icon" />
                          <span className="label">
                            {t("dynamic_form.special_handling_question")}:
                          </span>
                          <span className="value">
                            {transport.special_treatment == "1"
                              ? t("dynamic_form.yes")
                              : t("dynamic_form.no")}
                          </span>
                          {transport.special_treatment_details && (
                            <>
                              ,
                              <span className="value ms-1">
                                {transport.special_treatment_details}
                              </span>
                            </>
                          )}
                        </div>
                      )}

                      {transport.malfunction != null && (
                        <div className="info-item mb-2">
                          <FaQuestionCircle className="icon" />
                          <span className="label">
                            {t("dynamic_form.help_carry_question")}:
                          </span>
                          <span className="value">
                            {transport.malfunction == "1"
                              ? t("dynamic_form.yes")
                              : t("dynamic_form.no")}
                          </span>
                          {transport.malfunction_details && (
                            <>
                              ,
                              <span className="value ms-1">
                                {transport.malfunction_details}
                              </span>
                            </>
                          )}
                        </div>
                      )}

                      {/* {transport.item_type && transport.item_type.length > 0 && ( */}
                      <div className="mt-3">
                        <div className="mb-2 fw-semibold">
                          {t("clientTransportDetails.items")}:
                        </div>
                        {transport.item_type.map((item, index) => (
                          <div key={index} className="item-card mb-2">
                            <div className="d-flex justify-content-between align-items-start">
                              <div className="item-details">
                                <div className="item-name fw-semibold">
                                  {item} × {transport.num_items?.[index] || 1}
                                </div>
                                {transport.dimensions?.[index] && (
                                  <div className="item-dimensions text-muted small">
                                    <FaRulerCombined className="me-1" />
                                    {transport.dimensions?.[index]} cm
                                  </div>
                                )}
                                {(transport.item_weight?.[index] || transport.weight?.[index]) && (
                                  <div className="item-weight text-muted small">
                                    <FaWeightHanging className="me-1" />
                                    {formatNumber(
                                      transport.item_weight?.[index] || transport.weight?.[index]
                                    )}{" "}
                                    kg
                                  </div>
                                )}
                                {transport.board_number?.[index] && (
                                  <div className="item-weight text-muted small">
                                    <AiFillIdcard className="me-1" />
                                    {transport.board_number?.[index]}
                                  </div>
                                )}
                                {transport.making_year?.[index] && (
                                  <div className="item-weight text-muted small">
                                    <FaCalendar className="me-1" />
                                    {transport.making_year?.[index]}
                                  </div>
                                )}
                                {transport.driving?.[index] && (
                                  <div className="item-weight text-muted small">
                                    <HiWrenchScrewdriver className="me-1" />
                                    {t("delivery_summary.driving")}:{" "}
                                    {transport.driving?.[index] === "1"
                                      ? t("dynamic_form.driving_yes")
                                      : t("dynamic_form.driving_no")}
                                  </div>
                                )}
                                {/* {transport?.special_items && (
                                  <SpecialItemsSummary data={transport.special_items} />
                                )} */}
                              </div>
                              <Badge className="item-badge">#{index + 1}</Badge>
                            </div>
                          </div>
                        ))}
                      </div>
                      {/* )} */}
                      <div className="info-item mt-3 mb-2 pt-3 border-top">
                        <FaWeight className="icon" />
                        <span className="label">
                          {t("clientTransportDetails.total_weight")}:
                        </span>
                        <span className="value fw-bold">
                          {formatNumber(transport.total_weight)} kg
                        </span>
                      </div>

                      {transport?.price_offer && (
                        <>
                          <div className="info-item mt-3 mb-0 pt-3 border-top">
                            <FaMoneyBill className="icon" />
                            <span className="label">
                              {t("delivery_summary.priceOffer.title")}:
                            </span>
                            <span className="value fw-bold">
                              {transport.price_offer} €
                            </span>
                          </div>

                          {transport?.is_price_negotiable !== 0 && (
                            <div className="info-item mb-2">
                              <span className="label">
                                {t("delivery_summary.priceOffer.negotiable")}
                              </span>
                            </div>
                          )}                     
                        </>
                      )}

                      <div className="info-item mt-3 mb-2 pt-3 border-top">
                        <FaQuestionCircle className="icon" />
                        <span className="value fw-bold">
                          {t("delivery_summary.paymentTerm.title", "Zahlungsziel")}
                        </span>
                        <br />
                        <div>
                          <span className="label">
                            {t("delivery_summary.paymentTerm.hint", "Zahlungsziel")}
                          </span>
                          <span className="value fw-bold">
                            {PAYMENT_TERM_OPTIONS.find(
                              (option) => option.value === transport.payment_term
                            )?.label || "—"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* عرض كاردات الطلبات */}
          {!loading && orders.length > 0 && (
            <Card className="detail-card mt-4">
              <Card.Header>
                <div className="card-header-title">
                  <FaBox className="icon" />
                  {t("clientTransportDetails.orders")} ({orders.length})
                </div>
              </Card.Header>
              <Card.Body>
                {orders.map((order, index) => {
                  const unreadCount = ordersUnreadCounts[order.id] || 0;
                  const rating = order?.driverRating || order?.driver_rating || null;

                  return (
                    <Card
                      key={order.id}
                      className="p-3 shadow-sm border-0 mb-4 bg-grey-light"
                      style={{
                        borderRadius: "16px",
                      }}
                    >
                      <Row className="align-items-center">
                        {/* بيانات السائق */}
                        <Col md={8}>
                          <h6 className="fw-bold text-orange">
                            {order.driver_name || "No Driver Assigned"}
                          </h6>

                          <div className="mb-2">
                            <small className="text-muted">
                              {t("clientTransportDetails.vehicle")}:{" "}
                            </small>
                            <span>
                              {order.vehicle_type || "N/A"} -{" "}
                              {order.vehicle_number || "N/A"}
                            </span>
                          </div>

                          <div className="d-flex align-items-center mb-2">
                            <FaStar className="text-orange me-1" />
                            <span className="me-2">
                              {order.average_rating || "No ratings"}
                            </span>
                            <small className="text-muted">
                              ({order.total_reviews || 0} reviews)
                            </small>
                          </div>

                          <div className="d-flex align-items-center mb-2">
                            <FaTruck className="me-2 text-orange" />
                            <span className="fw-semibold">
                              {t("clientTransportDetails.current_location")}:{" "}
                              {order.current_location || "N/A"}
                            </span>
                          </div>

                          {/* 🔹 أزرار القبول والرفض */}
                          {showAcceptRejectButtons(order) && (
                            <div className="d-flex gap-2 my-3">
                              <Button
                                variant="success"
                                size="sm"
                                onClick={() => handleShowAcceptModal(order)}
                                disabled={processingAction}
                                style={{
                                  borderRadius: "20px",
                                  padding: "5px 15px",
                                }}
                              >
                                <FaThumbsUp className="me-1" />
                                {t("clientTransportDetails.accept_order")}
                              </Button>

                              <Button
                                className="bg-light-orange text-white border-0"
                                size="sm"
                                onClick={() => handleShowRejectModal(order)}
                                disabled={processingAction}
                                style={{
                                  borderRadius: "20px",
                                  padding: "5px 15px",
                                }}
                              >
                                <FaThumbsDown className="me-1" />
                                {t(
                                  "clientTransportDetails.reject_order_button",
                                )}
                              </Button>
                            </div>
                          )}
                        </Col>

                        {/* السعر والحالة */}
                        <Col
                          md={4}
                          className="d-flex flex-column justify-content-center align-items-center gap-2"
                        >
                          <Badge
                            bg={getStatusVariant(order.status)}
                            className="mb-2 text-uppercase fw-bold"
                            style={{ fontSize: "0.8rem" }}
                          >
                            {translateStatus(order.status)}
                          </Badge>

                          <div className="text-center mb-3">
                            <h5 className="fw-bold text-success mb-1">
                              <FaEuroSign className="me-1" />
                              {formatNumber(order.price)} {t("netto")}
                            </h5>
                            <small className="text-muted">
                              {t("clientTransportDetails.order")}:{" "}
                              {order.order_id}
                            </small>
                          </div>

                          {/* 🔹 زر عرض التفاصيل مع عدد الرسائل غير المقروءة */}
                          <div className="position-relative">
                            <Button
                              onClick={() => handleShowOrder(order)}
                              className="bg-orange text-white fw-bold position-relative border-0"
                            >
                              <FaComments className="me-1" />
                              {t("clientTransportDetails.view_order_details")}
                            </Button>
                            {unreadCount > 0 && (
                              <Badge
                                bg="danger"
                                className="position-absolute top-0 start-100 translate-middle"
                                style={{ fontSize: "0.7rem" }}
                              >
                                {unreadCount}
                              </Badge>
                            )}
                          </div>

                          {/* 🔹 Rating Button - الجديد */}
                          {transport?.status === "completed" && (
                            <Row className="justify-content-center mb-4">
                              <Col xs={12} md={12} className="text-center">
                                {(!transport.driverRating ||
                                  transport.driverRating.rating === 0) && (
                                  <Button
                                    onClick={() => setShowRatingModal(true)}
                                    className="bg-orange text-white fw-bold border-0"
                                  >
                                    {t("clientTransportDetails.give_rating")}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          )}

                          {/* التواريخ */}
                          {order.completed_date && (
                            <small className="text-muted mt-2 text-center">
                              {t("clientTransportDetails.completed")}:{" "}
                              {formatDate(order.completed_date)}
                            </small>
                          )}
                        </Col>

                        {rating ? (
                          <div className="mt-3 p-3 rounded-3 border bg-light">
                            {/* Header: العنوان + المتوسط */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <strong style={{ fontSize: 14 }}>
                                {t("clientTransportDetails.driver_rating", "Fahrerbewertung")}
                              </strong>
                              <div className="d-flex align-items-center gap-2">
                                <span style={{ color: "#f5b301", fontWeight: 700, fontSize: 16 }}>
                                  {Number(rating.average ?? rating.rating ?? 0).toFixed(2)}
                                </span>
                                <FaStar size={16} color="#f5b301" />
                              </div>
                            </div>

                            {/* المعايير - صف لكل معيار */}
                            <div className="d-flex flex-row gap-2 flex-wrap">
                              {/* Pünktlichkeit */}
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="text-muted small">
                                  {t("rating.criteria.punctuality.title", "Pünktlichkeit")}
                                </span>
                                <div className="d-flex gap-1">
                                  {[1, 2, 3, 4, 5].map((n) => (
                                    <FaStar
                                      key={n}
                                      size={14}
                                      color={n <= rating.punctuality ? "#f5b301" : "#e4e7ec"}
                                    />
                                  ))}
                                </div>
                              </div>

                              {/* Kommunikation */}
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="text-muted small">
                                  {t("rating.criteria.communication.title", "Kommunikation")}
                                </span>
                                <div className="d-flex gap-1">
                                  {[1, 2, 3, 4, 5].map((n) => (
                                    <FaStar
                                      key={n}
                                      size={14}
                                      color={n <= rating.communication ? "#f5b301" : "#e4e7ec"}
                                    />
                                  ))}
                                </div>
                              </div>

                              {/* Umgang mit der Ware */}
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="text-muted small">
                                  {t("rating.criteria.cargo_care.title", "Umgang mit der Ware")}
                                </span>
                                <div className="d-flex gap-1">
                                  {[1, 2, 3, 4, 5].map((n) => (
                                    <FaStar
                                      key={n}
                                      size={14}
                                      color={n <= rating.cargo_care ? "#f5b301" : "#e4e7ec"}
                                    />
                                  ))}
                                </div>
                              </div>

                              {/* Gesamtbewertung */}
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="text-muted small fw-semibold">
                                  {t("rating.criteria.rating.title", "Gesamtbewertung")}
                                </span>
                                <div className="d-flex gap-1">
                                  {[1, 2, 3, 4, 5].map((n) => (
                                    <FaStar
                                      key={n}
                                      size={14}
                                      color={n <= rating.rating ? "#f5b301" : "#e4e7ec"}
                                    />
                                  ))}
                                </div>
                              </div>
                            </div>

                            {/* التعليق */}
                            {rating.comment && (
                              <div className="mt-3 pt-2 border-top">
                                <p
                                  className="mb-0 fst-italic text-muted"
                                  style={{ fontSize: 13, lineHeight: 1.5 }}
                                >
                                  &quot;{rating.comment}&quot;
                                </p>
                              </div>
                            )}

                            {/* التاريخ */}
                            {rating.created_at && (
                              <div className="text-end mt-2">
                                <small className="text-muted" style={{ fontSize: 11 }}>
                                  {rating.created_at}
                                </small>
                              </div>
                            )}
                          </div>
                        ) : null}
                      </Row>
                    </Card>
                  );
                })}
              </Card.Body>
            </Card>
          )}

          {!loading && !error && orders.length === 0 && (
            <div className="no-orders-message">
              {t("clientTransportDetails.no_orders")}
            </div>
          )}

          {/* Modal لعرض تفاصيل الطلب */}
          <OrderDetailsModal
            show={showOrder}
            handleClose={() => setShowOrder(false)}
            order={selectedOrder}
            unreadCount={
              selectedOrder ? ordersUnreadCounts[selectedOrder.id] || 0 : 0
            }
            onMessagesRead={(orderId) => {
              // تحديث حالة الرسائل غير المقروءة عند قراءة الرسائل
              updateOrderUnreadCount(orderId, 0);
            }}
          />

          {/* 🔸 Accept Order Modal */}
          <Modal
            show={showAcceptModal}
            onHide={handleCloseAcceptModal}
            centered
            className="w-100"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <FaThumbsUp className="me-2" />
                {t("clientTransportDetails.accept_order")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {actionAlert.show && (
                <Alert variant={actionAlert.variant} className="mb-3">
                  {actionAlert.message}
                </Alert>
              )}

              {!actionAlert.show && orderToAccept && (
                <>
                  <Row>
                    <Col md={6} className="border-card">
                      <h6 className="text-orange fw-bold mb-3">
                        <FaMapMarkerAlt className="me-2" />
                        {t("clientTransportDetails.loading_info")}
                      </h6>

                      <Row className="mb-4">
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("postal_city")}</Form.Label>
                            <Form.Control
                              type="text"
                              name="booking_from"
                              value={acceptData.booking_from}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("company_name")}</Form.Label>
                            <Form.Control
                              type="text"
                              name="loading_name"
                              value={acceptData.loading_name}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("street_house")}</Form.Label>
                            <Form.Control
                              type="text"
                              name="loading_streat"
                              value={acceptData.loading_streat}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("phone_number")}</Form.Label>
                            <Form.Control
                              type="tel"
                              name="loading_phone"
                              value={acceptData.loading_phone}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("from")}</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="TT.MM.JJJJ"
                              name="loading_date_start"
                              value={acceptData.loading_date}
                              onChange={(e) => {
                                let value = e.target.value.replace(/[^\d]/g, "");
                                if (value.length > 2 && value.length <= 4) {
                                  value = value.slice(0, 2) + "." + value.slice(2);
                                } else if (value.length > 4) {
                                  value = value.slice(0, 2) + "." + value.slice(2, 4) + "." + value.slice(4, 8);
                                }
                                setAcceptData((prev) => ({
                                  ...prev,
                                  loading_date: value,
                                }));
                              }}
                              maxLength={10}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("to")}</Form.Label>
                            <Form.Control
                              type="time"
                              name="loading_time_start"
                              value={acceptData.loading_time_start}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>

                        {/* تاريخ ووقت نهاية التحميل - يظهر فقط عند الضغط على + */}
                        {showLoadingEnd && (
                          <>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>{t("from")}</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="TT.MM.JJJJ"
                                  name="loading_date_end"
                                  value={acceptData.loading_date_end}
                                  onChange={(e) => {
                                    let value = e.target.value.replace(/[^\d]/g, "");
                                    if (value.length > 2 && value.length <= 4) {
                                      value = value.slice(0, 2) + "." + value.slice(2);
                                    } else if (value.length > 4) {
                                      value = value.slice(0, 2) + "." + value.slice(2, 4) + "." + value.slice(4, 8);
                                    }
                                    setAcceptData((prev) => ({
                                      ...prev,
                                      loading_date_end: value,
                                    }));
                                  }}
                                  maxLength={10}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>{t("to")}</Form.Label>
                                <Form.Control
                                  type="time"
                                  name="loading_time_end"
                                  value={acceptData.loading_time_end}
                                  onChange={handleAcceptDataChange}
                                />
                              </Form.Group>
                            </Col>
                          </>
                        )}

                        <Col md={12}>
                          <div className="d-flex gap-2 mt-2">
                            {!showLoadingEnd ? (
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => setShowLoadingEnd(true)}
                                style={{ fontSize: "13px" }}
                              >
                                <FaPlus className="me-1" /> {t("route_form.add_pickup_end")}
                              </Button>
                            ) : (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => {
                                  setShowLoadingEnd(false);
                                  setAcceptData((prev) => ({
                                    ...prev,
                                    loading_date_end: "",
                                    loading_time_end: "",
                                  }));
                                }}
                                style={{ fontSize: "13px" }}
                              >
                                <FaTimes className="me-1" /> {t("route_form.remove_pickup_end")}
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>

                    <Col md={6}>
                      <h6 className="text-orange fw-bold mb-3">
                        <FaMapMarkerAlt className="me-2" />
                        {t("clientTransportDetails.unloading_info")}
                      </h6>

                      <Row className="mb-4">
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("postal_city")}</Form.Label>
                            <Form.Control
                              type="text"
                              name="booking_to"
                              value={acceptData.booking_to}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("company_name")}</Form.Label>
                            <Form.Control
                              type="text"
                              name="unloading_name"
                              value={acceptData.unloading_name}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("street_house")}</Form.Label>
                            <Form.Control
                              type="text"
                              name="unloading_streat"
                              value={acceptData.unloading_streat}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("phone_number")}</Form.Label>
                            <Form.Control
                              type="tel"
                              name="unloading_phone"
                              value={acceptData.unloading_phone}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("from")}</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="TT.MM.JJJJ"
                              name="unloading_date_start"
                              value={acceptData.unloading_date}
                              onChange={(e) => {
                                let value = e.target.value.replace(/[^\d]/g, "");
                                if (value.length > 2 && value.length <= 4) {
                                  value = value.slice(0, 2) + "." + value.slice(2);
                                } else if (value.length > 4) {
                                  value = value.slice(0, 2) + "." + value.slice(2, 4) + "." + value.slice(4, 8);
                                }
                                setAcceptData((prev) => ({
                                  ...prev,
                                  unloading_date: value,
                                }));
                              }}
                              maxLength={10}
                            />
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Label>{t("to")}</Form.Label>
                            <Form.Control
                              type="time"
                              name="unloading_time_start"
                              value={acceptData.unloading_time_start}
                              onChange={handleAcceptDataChange}
                            />
                          </Form.Group>
                        </Col>

                        {/* تاريخ ووقت نهاية التنزيل - يظهر فقط عند الضغط على + */}
                        {showUnloadingEnd && (
                          <>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>{t("from")}</Form.Label>
                                <Form.Control
                                  type="text"
                                  placeholder="TT.MM.JJJJ"
                                  name="unloading_date_end"
                                  value={acceptData.unloading_date_end}
                                  onChange={(e) => {
                                    let value = e.target.value.replace(/[^\d]/g, "");
                                    if (value.length > 2 && value.length <= 4) {
                                      value = value.slice(0, 2) + "." + value.slice(2);
                                    } else if (value.length > 4) {
                                      value = value.slice(0, 2) + "." + value.slice(2, 4) + "." + value.slice(4, 8);
                                    }
                                    setAcceptData((prev) => ({
                                      ...prev,
                                      unloading_date_end: value,
                                    }));
                                  }}
                                  maxLength={10}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <Form.Label>{t("to")}</Form.Label>
                                <Form.Control
                                  type="time"
                                  name="unloading_time_end"
                                  value={acceptData.unloading_time_end}
                                  onChange={handleAcceptDataChange}
                                />
                              </Form.Group>
                            </Col>
                          </>
                        )}

                        {/* أزرار التحكم في تواريخ التنزيل */}
                        <Col md={12}>
                          <div className="d-flex gap-2 mt-2">
                            {!showUnloadingEnd ? (
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => setShowUnloadingEnd(true)}
                                style={{ fontSize: "13px" }}
                              >
                                <FaPlus className="me-1" /> {t("route_form.add_delivery_end")}
                              </Button>
                            ) : (
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => {
                                  setShowUnloadingEnd(false);
                                  setAcceptData((prev) => ({
                                    ...prev,
                                    unloading_date_end: "",
                                    unloading_time_end: "",
                                  }));
                                }}
                                style={{ fontSize: "13px" }}
                              >
                                <FaTimes className="me-1" /> {t("route_form.remove_delivery_end")}
                              </Button>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={handleCloseAcceptModal}
                disabled={processingAction}
              >
                {t("clientTransportDetails.cancel")}
              </Button>
              <Button
                // variant="success"
                variant="orange"
                className="text-white"
                onClick={handleConfirmAccept}
                disabled={processingAction}
              >
                {processingAction ? (
                  <>
                    <Spinner
                      animation="border"
                      size="sm"
                      className="me-2 text-white"
                    />
                    {t("clientTransportDetails.accept_order")}...
                  </>
                ) : (
                  <>
                    <FaCheck className="me-2" />
                    {t("clientTransportDetails.accept_order")}
                  </>
                )}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* 🔸 Reject Confirmation Modal */}
          <Modal
            show={showRejectModal}
            onHide={handleCloseRejectModal}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title className="text-orange">
                <FaThumbsDown className="me-2" />
                {t("clientTransportDetails.reject_order")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {actionAlert.show && (
                <Alert variant={actionAlert.variant} className="mb-3">
                  {actionAlert.message}
                </Alert>
              )}

              {!actionAlert.show && orderToReject && (
                <>
                  <p className="fw-bold">
                    {t("clientTransportDetails.confirm_reject")}
                  </p>
                  <div className="mb-3 p-3 border rounded bg-light">
                    <p className="mb-1">
                      <strong>{t("clientTransportDetails.order")} ID:</strong>{" "}
                      {orderToReject.order_id || orderToReject.booking_id}
                    </p>
                    <p className="mb-0 text-muted">
                      <small>
                        Transport ID: {orderToReject.transportId},{" "}
                        {t("clientTransportDetails.order")} ID:{" "}
                        {orderToReject.orderId}
                      </small>
                    </p>
                  </div>

                  <Form.Group className="mb-3">
                    <Form.Label>
                      <strong>
                        {t("clientTransportDetails.reason_rejection")}
                      </strong>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={rejectReason}
                      onChange={(e) => {
                        setRejectReason(e.target.value);
                        if (rejectReasonError && e.target.value.trim()) {
                          setRejectReasonError("");
                        }
                      }}
                      placeholder={t(
                        "clientTransportDetails.reject_placeholder",
                      )}
                      isInvalid={!!rejectReasonError}
                      disabled={processingAction}
                    />
                    <Form.Control.Feedback type="invalid">
                      {rejectReasonError}
                    </Form.Control.Feedback>
                  </Form.Group>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={handleCloseRejectModal}
                disabled={processingAction}
              >
                {t("clientTransportDetails.cancel")}
              </Button>
              <Button
                className="bg-light-orange text-white border-0"
                onClick={handleConfirmReject}
                disabled={processingAction || !rejectReason.trim()}
              >
                {processingAction ? (
                  <>
                    <Spinner
                      animation="border"
                      size="sm"
                      className="me-2 text-white"
                    />
                    {t("clientTransportDetails.reject_order")}...
                  </>
                ) : (
                  <>
                    <FaThumbsDown className="me-2" />
                    {t("clientTransportDetails.confirm_reject_button")}
                  </>
                )}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* ⭐ Rating Modal - الجديد */}
          {/* <Modal
            show={showRatingModal}
            onHide={() => setShowRatingModal(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {t("clientTransportDetails.submit_rating")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="text-center mb-3">
                {[...Array(5)].map((_, index) => (
                  <FaStar
                    key={index}
                    size={30}
                    className={`me-2 ${index < selectedRating ? "text-orange" : "text-muted"
                      }`}
                    onClick={() => setSelectedRating(index + 1)}
                    style={{ cursor: "pointer" }}
                  />
                ))}
              </div>
              <Form.Group>
                <Form.Label>{t("clientTransportDetails.comment")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder={t(
                    "clientTransportDetails.write_rating_placeholder",
                  )}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowRatingModal(false)}
              >
                {t("clientTransportDetails.cancel")}
              </Button>
              <Button
                className="bg-orange text-white border-0"
                onClick={handleSubmitRating}
                disabled={submitting || selectedRating === 0}
              >
                {submitting
                  ? t("clientTransportDetails.submit") + "..."
                  : t("clientTransportDetails.submit")}
              </Button>
            </Modal.Footer>
          </Modal> */}
          <DriverRatingModal
            show={showRatingModal}
            onHide={() => setShowRatingModal(false)}
            role="driver"
            person={{
              name: transport?.order?.driver_name || transport?.driver_name || "—",
              id: transport?.order?.customer_id || transport?.order?.driver_id || "—",
              avatar: transport?.order?.driver_avatar || null,
            }}
            onSubmit={handleSubmitRating}
            submitting={submitting}
          />
        </Container>
      </div>

      <Footer />

      {(userType === "client" || userType === "driver") && (
        <ClientChatBox userType={userType} />
      )}
    </>
  );
}
